'use client';

import { useRef, useEffect, useCallback } from 'react';
import { useCallbackRef } from '../use-callback-ref/use-callback-ref.mjs';
function useDebouncedCallback(callback, delay) {
  var handleCallback = useCallbackRef(callback);
  var debounceTimerRef = useRef(0);
  useEffect(function () {
    return function () {
      return window.clearTimeout(debounceTimerRef.current);
    };
  }, []);
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    window.clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = window.setTimeout(function () {
      return handleCallback.apply(void 0, args);
    }, delay);
  }, [handleCallback, delay]);
}
export { useDebouncedCallback };